import { DEFAULT_MODE, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const titleFont = getFont(FONT.PARIS_3);

export const colors = {
  separator: makeThemeColor(PRIMARY, 0.3),
};

export const SPACER = {
  [HD]: 32,
  [FULL_HD]: 40,
};

// The spacer acts as a margin for the left part, but as a padding for the right part
export const WIDTH = {
  [HD]: 412 + SPACER[HD],
  [FULL_HD]: 588 + SPACER[FULL_HD],
};

export const SEPARATOR = {
  [HD]: 2,
  [FULL_HD]: 4,
};

export const STEPS_GAP = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const BUTTONS_GAP = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const leftWidth = WIDTH[screenSize] - SPACER[screenSize];

  return {
    w: WIDTH[screenSize],
    Static: {
      x: safetyMargins.horizontal[screenSize],
      w: leftWidth,
      flex: {
        direction: 'column',
      },
      Title: {
        text: {
          wordWrapWidth: leftWidth,
          maxLines: 2,
        },
        flexItem: {
          marginBottom: STEPS_GAP[screenSize],
        },
      },
      Feature0: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize],
        },
      },
      Feature1: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize],
        },
      },
      Feature2: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize],
        },
      },
    },
    Buttons: {
      x: safetyMargins.horizontal[screenSize],
      w: leftWidth,
      flex: {
        direction: 'column',
        justifyContent: 'flex-end',
        alignItems: 'stretch',
      },
    },
    Separator: {
      rect: true,
      x: safetyMargins.horizontal[screenSize] + WIDTH[screenSize],
      w: SEPARATOR[screenSize],
      color: colors.separator[colorMode],
    },
  };
};
